import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "pb-2.5 font-bold em88:first:pt-2.5" }, "Marke", -1)
const _hoisted_2 = { class: "mb-4 border-b border-b-gray-40 pb-3 last:mb-0 last:border-b-0 last:pb-0" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "pb-2.5 font-bold em88:first:pt-2.5" }, "Kategorien", -1)
const _hoisted_4 = { class: "mb-4 border-b border-b-gray-40 pb-3 last:mb-0 last:border-b-0 last:pb-0" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "pb-2.5 font-bold em88:first:pt-2.5" }, "Weitere Vorschläge", -1)

import useFindings from "@/composables/use-findings";
import FindingsShopItem from "./FindingsShopItem.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'FindingsShop',
  setup(__props) {

const { findings } = useFindings();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(findings).brands.length > 0)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _hoisted_1,
          _createElementVNode("div", _hoisted_2, [
            _createVNode(FindingsShopItem, {
              findings: _unref(findings).brands
            }, null, 8, ["findings"])
          ])
        ], 64))
      : _createCommentVNode("", true),
    (_unref(findings).categories.length > 0)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createVNode(FindingsShopItem, {
              findings: _unref(findings).categories
            }, null, 8, ["findings"])
          ])
        ], 64))
      : _createCommentVNode("", true),
    (_unref(findings).others.length > 0)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          _hoisted_5,
          _createVNode(FindingsShopItem, {
            findings: _unref(findings).others
          }, null, 8, ["findings"])
        ], 64))
      : _createCommentVNode("", true)
  ], 64))
}
}

})